var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnarchive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      transform: "rotate(-180deg)"
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.668,
    viewBox: "0 0 15 15.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "archive",
    transform: "translate(-2581 -13873)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4629",
    "data-name": "Rectangle 4629",
    width: 15,
    height: 15,
    transform: "translate(2581 13873)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16195",
    "data-name": "Group 16195",
    transform: "translate(0 0.668)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4629-2",
    "data-name": "Rectangle 4629",
    width: 15,
    height: 15,
    transform: "translate(2581 13873)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "black",
    d: "M-2455.969,12A2.033,2.033,0,0,1-2458,9.969V1.031A2.034,2.034,0,0,1-2455.969-1h8.937A2.034,2.034,0,0,1-2445,1.031V9.969a2.034,2.034,0,0,1-2.031,2.03Zm-1.016-10.968V9.969a1.017,1.017,0,0,0,1.016,1.015h8.937a1.018,1.018,0,0,0,1.016-1.015V1.031a1.017,1.017,0,0,0-1.016-1.016h-8.937A1.017,1.017,0,0,0-2456.985,1.031Zm4.964,7.9V5.608l-.514.515a.487.487,0,0,1-.346.143.483.483,0,0,1-.344-.143.488.488,0,0,1,0-.692l0,0,.156-.157.323-.324.382-.382c.107-.108.212-.216.321-.322a1.432,1.432,0,0,1,.283-.249.435.435,0,0,1,.12-.045.47.47,0,0,1,.428.121c.113.1.22.208.325.316s.222.22.332.33l.335.335.26.26.106.106a.489.489,0,0,1,0,.691.485.485,0,0,1-.346.144.488.488,0,0,1-.345-.144l-.5-.5V8.934a.488.488,0,0,1-.489.489A.489.489,0,0,1-2452.021,8.934Zm-1.955-6.213a.471.471,0,0,1-.413-.468.471.471,0,0,1,.413-.468h4.943a.479.479,0,0,1,.422.468.479.479,0,0,1-.422.468Z",
    transform: "translate(137 13886) rotate(180)",
    fill: "#6992c4",
    stroke: "#fff",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/unarchive.e3e0ef4521850f1afe3e7bba66f7c986.svg";
export { ForwardRef as ReactComponent };